export type ButtonType = "primary" | "secondary" | "link"  | "default" | "default-alt";

export type ButtonSize = "xs" | "sm" | "md" | "lg";

export type ButtonBlock = false;

export type ButtonRounded = 'sm' | 'md' | 'lg' | 'xl' | 'full';
